import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const FooterContainer = styled.footer`
  width: 100%;
  background: #e97d7dff;
  color: #fff;
  text-align: center;
  padding: 2rem 1rem 1rem 1rem;
  margin-top: auto;
`;

const FooterLinks = styled.div`
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
`;

const FooterLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
  &:hover {
    color: #000;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const Copyright = styled.div`
  font-size: 0.97rem;
  opacity: 0.8;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterLinks>
        <FooterLink to="/shop">Shop</FooterLink>
        <FooterLink to="/aboutus">About Us</FooterLink>
        <FooterLink to="/contact">Contact</FooterLink>
        <FooterLink to="/terms-and-conditions">Terms & Conditions</FooterLink>
      </FooterLinks>
      <Copyright>
        &copy; {new Date().getFullYear()} 💕Craft Bin . All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
